import React, { useContext, useEffect, useState } from "react";

import ClaimStatusDetailsGrid_v2 from "./ClaimStatusDetailsGrid_v2";

import { IMemberDetails } from "../../../types/memberDetails.types";
import { IClaim_V2_Details } from "../../../types/claim_v2.types";
import { api } from "../../../utils/api";
import { Paper } from "@mui/material";
import { AuthContext, GroupOwnerContext } from "../../../contexts";
import { trackPromise } from "react-promise-tracker";
import CircularLoader from "../../shared/loader/CircularLoader";

const ClaimStatus_v2 = () => {
	const [memberDetails, setMemberDetails] = useState<IMemberDetails | null>(null);
	const [loading, setLoading] = useState(true);
	const [claimStatusDetails, setClaimStatusDetails] = useState<IClaim_V2_Details[]>([]);
	const { member } = useContext(AuthContext);

	const { groupOwner } = useContext(GroupOwnerContext);
	const fetchClaimStatusDetails = async (member: any) => {
		setLoading(true);
		const getClaimsQuery = {
			SSN: member.SSN,
			group_number: member.group_number
		};
		try {
			const response = await trackPromise(api.claim.getClaimListV2(getClaimsQuery));
			setClaimStatusDetails(response?.claimResult);
			setMemberDetails(response?.memberResult);
			// handle the response
		} catch (error: any) {
			// alert("Failed to fetch claim status details.");
			alert("No claim status details found.");
			console.error("Error fetching claim status details:", error);
		} finally {
			setLoading(false);
		}
	};

	const permission = (groupOwner as any)?.permissions.find(
		(group: any) => group.group_number === member?.group_number
	)["permission_and_subscription"]?.permissions?.employer_members_menu.self.members_list_table.member_details_view;

	useEffect(() => {
		if (member) {
			fetchClaimStatusDetails(member);
		}
	}, [member]);

	return (
		<>
			<div
				style={{
					height: "400px",
					width: "90%",
					margin: "auto",

					textAlign: "center",
					marginTop: "40px"
				}}
			>
				{/* <div className="pf-title" style={{ marginTop: "35px", marginBottom: "20px" }}>
					Claim Status
				</div> */}
				{!permission || permission.claims_tab.view ? (
					<>
						{loading && <CircularLoader />}
						<Paper className="theme-border-radius paper-container">
							<ClaimStatusDetailsGrid_v2
								memberDetails={memberDetails}
								claimStatusList={claimStatusDetails}
							/>
						</Paper>
					</>
				) : (
					<div>No Permission</div>
				)}
			</div>
		</>
	);
};

export default ClaimStatus_v2;
